module.exports = __webpack_public_path__ + "img/gb-sct.27d33587.svg";